import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useRingStyle } from '../../../../tailwind_common/util';
export var WidgetButton = function (props) {
    var handleClick = props.handleClick, className = props.className, children = props.children, disabled = props.disabled;
    var ringStyle = useRingStyle();
    return (React.createElement("button", { className: twMerge('tw-focus box-border rounded-md border border-solid border-gray-300 bg-white px-5 py-4 text-black shadow-widget-button hover:bg-gray-50', className), onClick: handleClick, style: ringStyle, disabled: disabled }, children));
};
export default WidgetButton;
